import { validateTidalLicense } from "../base/index.js";
function isPlainObject(obj) {
  if (!hasObjectPrototype(obj)) {
    return false;
  }
  const ctor = obj.constructor;
  if (typeof ctor === "undefined") {
    return true;
  }
  const prot = ctor.prototype;
  if (!hasObjectPrototype(prot)) {
    return false;
  }
  if (!prot.hasOwnProperty("isPrototypeOf")) {
    return false;
  }
  return true;
}
function hasObjectPrototype(o) {
  return Object.prototype.toString.call(o) === "[object Object]";
}
validateTidalLicense();
export {
  isPlainObject
};
//# sourceMappingURL=isPlainObject.js.map
